module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sharedcomponents/_directive/footer/footer.component.css
// module id = ./src/app/sharedcomponents/_directive/footer/footer.component.css
// module chunks = main